import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { map, Observable } from 'rxjs';
import {
  IDataExamenesAtencion,
  IDataExamn,
  IDataTypeExamn,
  IGenericResponse,
} from '../interfaces/examenes.interface';
import { IndexdbService } from '../../core/database/indexdb.service';

export interface RespUploadFile {
  success: boolean;
  data: UploadedFile;
  error: string | null;
}

export interface UploadedFile {
  destination: string;
  fileName: string;
}

@Injectable({
  providedIn: 'root',
})

export class TabExamenesService {
  private readonly indexDbService: IndexdbService = inject(IndexdbService);

  private filesApiUrl = environment.baseURL + 'files';
  private fichaClinicaApiUrl = environment.baseURL + 'ficha-clinica';

  constructor(private httpClient: HttpClient) { }

  getTypesExams(): Observable<IDataTypeExamn[]> {
    return this.indexDbService.getDatosMedicos().pipe(
      map(result => result?.tipoExamenes ?? [])
    );
  }

  getExamsByType(): Observable<IDataExamn[]> {
    return this.indexDbService.getDatosMedicos().pipe(
      map(result => result?.listaExamenes ?? [])
    );
  }

  uploadFile(file: File, idPaciente: string, idAgendamiento: string): Observable<RespUploadFile> {
    const formData = new FormData();
    formData.append('file', file);
    return this.httpClient.post<RespUploadFile>(this.filesApiUrl + `/upload/${idPaciente}/${idAgendamiento}`, formData);
  }

  deleteFile(url: string): Observable<{ message: string }> {
    return this.httpClient.delete<{ message: string }>(this.filesApiUrl + `/delete-file`, {
      params: { url },
    });
  }

  getExamenesAtencion(idAgendamiento: string): Observable<IGenericResponse<IDataExamenesAtencion>> {
    return this.httpClient.get<IGenericResponse<IDataExamenesAtencion>>(this.fichaClinicaApiUrl + `/examenes/${idAgendamiento}`);
  }

}
